<template>
	<!-- 帳戶設定》修改商家資訊 -->
	<div class="deal_index_box">
		<!-- 内容 -->
		<div class="deal_title">
			<div>帳戶設定<span>》</span>修改商家資訊</div>
			<div class="deal_hr">
				<div class="cut_off"></div>
			</div>
		</div>
		<!-- 修改商家資訊 -->
		<div class="deal_content_box">
			<div class="deal_content_title">最高權限管理員資訊 <span></span></div>
			<el-form ref="form" :model="formMail" label-width="100px" size="mini" class="deal_content div_hight_end">
				<el-form-item label="營業登記證：">
					<input type="file" id="file_front" accept="image/*">
					<div v-show="formMailSucc.fileFront">
						<img id="front_img" src="" alt="">
					</div>
					<div class="file_text">
						僅接受jpg、gif、png圖片類型檔案
						<i class="el-icon-error" v-show="formMailTF.fileFront"></i>
					</div>
				</el-form-item>
				<el-form-item>
					<el-col :span="4" :xs="8" class="img_title">
						<img src="" alt="">
					</el-col>
				</el-form-item>
				<el-form-item label="公司名稱:" prop="name">
					<el-col :span="6">
						<el-input v-model="formMail.name"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="統一稱號:" prop="trader">
					<el-col :span="6">
						<el-input v-model="formMail.trader"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="負責人姓名:" prop="full_name">
					<el-col :span="6">
						<el-input v-model="formMail.full_name"></el-input>
					</el-col>
				</el-form-item>
			</el-form>
		</div>

		<!-- 最高權限管理員資訊	 -->
		<div class="deal_content_box">
			<div class="deal_content_title">最高權限管理員資訊 <span></span></div>
			<div class="deal_content div_hight_end">
				<el-row class="list_high_end">
					<el-col :span="4" :xs="8">
						姓名：<span>陳*玲</span>
					</el-col>
					<el-col :span="5" :xs="8">
						綁定手機：<span>091******33</span>
					</el-col>
					<el-col :span="6" :xs="8">
						綁定郵箱：<span>adl******@gmail.com</span>
					</el-col>
				</el-row>
			</div>
		</div>
		<!-- 經營資訊 -->
		<div class="deal_content_box">
			<div class="deal_content_title">經營資訊 <span></span></div>
			<el-form ref="form" :model="sizeForm" label-width="100px" size="mini" class="deal_content div_hight_end">
				<el-form-item label="店家簡稱:" prop="date2">
					<el-col :span="4">
						<el-input v-model="formMail.date2"></el-input>
					</el-col>
					<el-col :span="4" class="color_list_e">
						簡稱將顯示給消費者
					</el-col>
				</el-form-item>
				<el-form-item label="客服電話：" prop="resource">
					<el-col :span="4">
						<el-input v-model="formMail.resource"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="經營類別：" prop="date1">
					<el-col :span="6">
						<el-select v-model="formMail.date1" placeholder="">
							<el-option label="服飾" value="shanghai"></el-option>
							<el-option label="電器" value="beijing"></el-option>
						</el-select>
					</el-col>

				</el-form-item>
				<el-form-item label="銷售通路：" prop="region">
					<el-col :span="6" :xs="16">
						<el-checkbox-group v-model="region" class="check_right">
							<el-checkbox label="實體店面"></el-checkbox>
							<el-checkbox label="網絡商店"></el-checkbox>
							<el-checkbox label="app"></el-checkbox>
							<el-checkbox label="其他"></el-checkbox>
						</el-checkbox-group>
					</el-col>
					<el-col :span="4">
						<el-input v-model="formMail.resource"></el-input>
					</el-col>
				</el-form-item>
			</el-form>
		</div>
	</div>



</template>

<script>
	export default {
		data() {
			return {

				formMail: {
					fileFront: '',
					trader: '',
					name: '',
					full_name: '',
				},

				sizeForm: {
					region: '',
					date1: '',
					date2: '',
					resource: '',
				},
				formMailTF: {
					email: false,
					password: false,
					checkPass: false,
					companyName: false,
					companyNumber: false,
					principal: false,
					identity: false,
					identityTime: false,
					siteValue: false,
					authentication: false,
					// 上传：1~3
					fileBusiness: false,
					fileFront: false,
					fileReverse: false
				},
				formMailSucc: {
					email: false,
					password: false,
					checkPass: false,
					companyName: false,
					companyNumber: false,
					principal: false,
					identity: false,
					identityTime: false,
					siteValue: false,
					authentication: false,
					// 上传：1~3
					fileBusiness: false,
					fileFront: false,
					fileReverse: false
				},
			};
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 表頭 */
	.deal_index_box {
		margin: 20px;
		font-size: 15px;
		color: black;
	}

	.deal_title {
		display: flex;
		justify-content: flex-start;
		padding-bottom: 10px;
	}

	.deal_title span {
		margin-left: 15px;
		margin-right: 8px;
	}

	.deal_title .deal_hr {
		flex: 1;
		margin-left: 18px;
	}

	.deal_title .deal_hr .cut_off {
		height: 3px;
		background: black;
		margin-top: 8px;
	}

	/* 内容 */
	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}

	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		/* min-height: 100px; */
		border: 1px solid #666666;
		background: #ffffff;
		padding: 0 20px;
		padding-top: 26px;
	}

	.deal_content_span {
		margin-left: 23px;
		font-size: 11px;
		color: #e73262;
	}

	.deal_content_tab_first {
		width: 960px;
		margin: 0 auto;
	}

	.deal_content_tab_first>div {
		margin: 14px 0;
	}



	.deal_content_title span {
		display: block;
		height: 35px;
		width: 30px;
		float: right;
		padding-left: 10px;
		padding-top: 5px;
		background: url("../../../../assets/img/user/service_list.png") center no-repeat;
	}



	.div_bottom div {
		margin-bottom: 25px;
		color: #777777;
	}




	/* 按鈕 */
	.input_high .el-input .el-input__inner {
		height: 27px;
		border: 1px solid #cccccc;
	}

	.input_high .el-input i {
		line-height: 30px;
	}

	.input_high {
		padding-left: 10px;
	}

	.check_right label {
		margin-right: 5px;
	}

	.list_tile_sed {
		background-color: #fff4cc;
		line-height: 40px;
		margin: 10px 100px 25px 10px;

	}

	.colro-red {
		color: #ff4a05;
		font-size: 20px;
	}

	.list_span ,.color_list_e{
		padding-left: 10px;
		color: #e73262;
	}

	.right_col {
		float: left;
	}

	.right_col_left {
		color: #4d80e7;
		padding-left: 15px
	}

	.list_span_end {
		color: #e73262;
		padding-left: 15px;
	}

	.div_bntoon {
		color: #e73262;
		border-bottom: 1px solid #e73262;
	}

	.button_cetent {
		padding-bottom: 5px;
		padding-left: 10px;
	}

	.button_cetent button {
		background-color: #ff771a;
		border: #ff771a;
		height: 20px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 3px;
		padding-right: 3px;
		width: 90px;
		font-size: 11px;
	}

	.button_stend {
		padding-bottom: 25px;
		margin-left: 10px;
	}

	.button_stend_stes button {
		height: 22px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 8px;
		padding-right: 10px;
		width: 75px;
		font-weight: 700;
	}

	.button_stend button {

		height: 22px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 8px;
		padding-right: 10px;
		width: 45px;
		font-weight: 700;
	}

	.painde_top {
		padding: 50px;
	}

	.bottom_onew {
		color: #e73262;
		border-color: #e73262;
	}

	.bottom_two {
		background: #e73262;
		color: #FFFFFF;

	}

	.icon_phigt {
		padding: 5px;
		margin-bottom: 100px;
	}

	.paind_bottm_end {
		padding-bottom: 10px;
	}

	.input_high i {
		font-size: 30px;
	}

	.list_span_str {
		font-weight: 700;
		color: #e73262;
		margin-left: -80px;
		font-size: 15px;
	}

	.flex_display {
		display: flex;
	}

	.el-form-item {
		margin-bottom: 5px;
	}

	.phone_box .progress_box {
		position: relative;
		line-height: 18px;
		margin: 0 auto;
		margin-top: 40px;
		margin-bottom: 40px;
		overflow: hidden;
		color: #777777;
	}

	.progress_step {
		display: flex;
		justify-content: center;
		align-items: center;
		color: #e73262;
	}

	.progress_step>div {
		box-sizing: border-box;
		line-height: 18px;
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.progress_step>div>span {
		margin: 0 6px;
	}

	.progress_step .active {
		color: #e73262;
	}

	.progress_box .step_back {
		height: 9px;
		width: 620px;
		background: #fdeaef;
		position: absolute;
		bottom: 0;
		left: 50%;
		margin-left: -310px;
		z-index: -1;
	}

	.progress_box .icon_step {
		display: inline-block;
		height: 17px;
		width: 17px;
	}

	/* 01-建立帳號 */
	.account_box {
		box-sizing: border-box;
		border: 2px solid #bbbbbb;
		font-size: 13px;
		color: #bbbbbb;
		overflow: hidden;
		width: 970px;
		min-width: 970px;
		margin: 0 auto;
		padding: 36px 0;
		margin-bottom: 38px;
		display: flex;
		justify-content: center;
	}

	.account {
		overflow: hidden;
		width: 660px;
		line-height: 21px;
		margin: 0 auto;
	}

	.account .el-form-item__label {
		font-size: 13px;
	}

	.verification_success {
		color: #6ac259;
		font-size: 15px;
		line-height: 21px;
		margin-left: 10px;
	}

	.verification_error {
		color: #e73262;
		font-size: 15px;
		line-height: 21px;
		margin-left: 10px;
	}

	.account .phone_options {
		width: 100px;
	}

	.account .account_input {
		width: 260px;
		margin: 0 14px;
	}

	.account .account_verification {
		width: 280px;
	}

	.account .account_button {
		width: 160px;
	}

	.account .account_alert {
		width: 240px;
	}

	.account .account_next {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 70px 0 20px 0;
	}

	.account .account_next button {
		width: 124px;
		background: #e73262;
		color: white;
		border-radius: 6px;
		text-align: center;
		padding: 10px 0;
		margin: 0 21px;
		cursor: pointer;
	}

	.account .account_next .gray {
		background: #999999;
	}

	.account .account_consent {
		font-size: 13px;
		text-align: center;
		color: #777777;
	}

	.account .account_consent .consent_true {
		margin-left: 8px;
	}

	.account .account_consent input {
		width: 16px;
		height: 16px;
	}

	.account .account_consent label {
		padding-bottom: 2px;
		border-bottom: 1px solid #999999;
		margin: 0 6px;
	}

	/* 02-完善資料 */
	#business_img,
	#front_img,
	#reverse_img {
		max-width: 400px;
	}

	.account_fun {
		cursor: pointer;
	}

	.form_buttons {
		font-size: 9px;
		margin: 0;
		color: #e73262;
		margin-left: 10px;
	}

	.form_buttons_succ {
		color: #6ac259;
	}

	.file_text {
		color: #e73262;
	}

	.information_box {
		box-sizing: border-box;
		border: 2px solid #bbbbbb;
		font-size: 17px;
		color: #777777;
		overflow: hidden;
		width: 970px;
		min-width: 970px;
		margin: 0 auto;
	}

	.information_box .el-form-item__label {
		font-size: 13px;
	}

	.information_box .title_box {
		height: 55px;
		line-height: 55px;
		background: #f2f2f2;
		text-align: center;
	}

	.information_box .title_box span {
		font-weight: bold;
	}

	.information_box .title_box .active {
		color: #e73262;
	}

	.information_box .information_form_title {
		box-sizing: border-box;
		width: 720px;
		margin: 0 auto;
		margin-top: 34px;
		margin-bottom: 40px;
		font-weight: bold;
		color: #777777;
		border-left: #e73262 12px solid;
		padding-left: 10px;
	}

	.form_mail_box {
		width: 800px;
		margin: 0 auto;
	}

	.form_mail .form_mail_input {
		width: 400px;
	}

	.information_form_next {
		display: flex;
		justify-content: center;
		margin-bottom: 50px;
	}

	.information_form_next button {
		width: 124px;
		background: #e73262;
		color: white;
		border-radius: 6px;
		text-align: center;
		padding: 4px 0;
		margin: 0 21px;
		cursor: pointer;
	}

	.information_form_next .gray {
		background: #999999;
	}

	/*  */
	/* .identity_box  span{
	    margin: 0 10px;
	  } */
	.identity_box .identity_box_select {
		width: 70px;
	}

	.identity_box .select_year {
		width: 100px;
	}

	.identity_box .span_first {
		margin-right: 10px;
	}

	.identity_box .span_text {
		margin: 0 10px;
	}

	.identity_box .span_last {
		margin-left: 10px;
	}

	.bank_box {
		width: 620px;
		margin-left: 40px;
	}

	.bank_box .bank_name_box {
		display: flex;
		justify-content: flex-start;
	}

	.bank_box .bank_name_box li {
		font-size: 15px;
		box-sizing: border-box;
		display: inline-block;
		height: 43px;
		line-height: 43px;
		width: 310px;
		text-align: center;
		background: #f2f2f2;
	}

	.bank_box .bank_name_box .active {
		border: #e73262 solid 2px;
		background: white;
		border-bottom: 0px;
	}

	.bank_box .bank_content {
		box-sizing: border-box;
		border: #e73262 solid 2px;
		padding: 48px 30px;
		padding-bottom: 30px;
	}

	.hotel_box {
		padding-left: 30px;
	}

	.hotel_box .hotel_box_input {
		width: 240px;
	}

	.hotel_box .hotel_box_text {
		color: #e73262;
		margin-left: 22px;
	}

	.type_box {
		width: 440px;
	}

	/* 03-送出申请 */
	#business_img_to,
	#front_img_to,
	#reverse_img_to {
		max-width: 400px;
	}

	.hotel_list_for>span {
		float: left;
		margin: 0 5px;
	}

	.icon_check_box {
		border: 1px solid #777;
	}

	/* 银行系列 */
	.form_bank_box {
		height: 18px;
	}

	.form_bank {
		font-size: 13px;
		color: #e73262;
		text-align: center;
		display: flex;
		justify-content: center;
		line-height: 18px;
	}

	.right_box {
		height: 40px;
		display: flex;
		justify-content: flex-start;
	}

	/* 发送审核 */
	.button_box {
		display: flex;
		justify-content: center;
		width: 600px;
		margin: 0 auto;
		margin-top: 40px;
		margin-bottom: 50px;
	}

	.button_box .btns_sty {
		margin: 0 30px;
	}

	.list_high_end {
		padding-bottom: 30px;
	}
	.el-form-item__label {
    color: #000000;
	}
</style>
